import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Configs
import { SnackBarConfig } from '../../../shared/configs/snackbar.config';

// Interfaces

// Services
import { SupplierSkuApiService } from '../../../shared/services/api/supplier/supplier-sku-api.service';

// Utils
import { trackById } from '../../../shared/util/track-by.util';
import { ISupplierSku } from '../../../supplier/interfaces/supplier-sku.interface';
import { ISupplier } from '../../../supplier/interfaces/supplier.interface';

@Component({
  selector: 'lum-rfq-supplier-skus-table',
  templateUrl: './rfq-supplier-skus-table.component.html',
  styleUrls: ['./rfq-supplier-skus-table.component.scss'],
})
export class RfqSupplierSkusTableComponent implements OnInit {
  @Input()
  form :UntypedFormGroup;

  @Input()
  suppliers :ISupplierSku[] = [];

  @Output()
  refreshSupplierSkuEvent :EventEmitter<boolean> = new EventEmitter<boolean>();

  loadingSupplier :boolean = false;
  suppliersPreviousList :ISupplierSku[] = [];

  trackById = trackById;

  private onDestroy$ = new Subject<void>();

  constructor(
    private snackBar :MatSnackBar,
    private supplierSkuApiService :SupplierSkuApiService,
  ) {}

  ngOnInit() :void {
    this.suppliersPreviousList = this.suppliers;
  }

  onSearchSupplierChange(keyword :string) :void {
    if (keyword === '') {
      this.suppliers = this.suppliersPreviousList;
    } else {
      const lowerCaseKeyword = keyword.toLowerCase();
      this.suppliers = this.suppliers.filter((item :any) =>
        item.factory_name.toLowerCase().includes(lowerCaseKeyword),
      );
    }
  }

  onSelectSupplier(
    supplier :ISupplier,
    supplierSkuControl :UntypedFormControl,
  ) :void {
    const supplierSku = supplierSkuControl.value;

    this.updateSupplierSku(supplierSku.id, {
      productId: supplierSku.productId,
      supplierId: supplier.id,
      sku: supplierSku.sku,
    });
  }

  onUpdateSupplierSku(sku :string, supplierSkuControl :UntypedFormControl) :void {
    const supplierSku = supplierSkuControl.value;

    this.updateSupplierSku(supplierSku.id, {
      productId: supplierSku.productId,
      supplierId: supplierSku.supplierId,
      sku,
    });
  }

  private updateSupplierSku(
    supplierSkuId :number,
    data :{ productId :number; supplierId :number; sku ?:string },
  ) :void {
    this.supplierSkuApiService
      .update(supplierSkuId, data)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: () => {
          this.snackBar.open('Supplier SKU successfully updated.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
        error: (err) => {
          this.snackBar.open(err.error, 'Error', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  get supplierSkusControl() :UntypedFormArray {
    return this.form.get('supplierSkus') as UntypedFormArray;
  }
}
